export default "__VITE_ASSET__E_q9rLSY__"